import AgreementType from 'components/blocks/Delta/Inputs/AgreementType';
import FieldsetContainer from 'components/blocks/Delta/Inputs/Containers/FieldsetContainer';
import Province from 'components/blocks/Delta/Inputs/Province';
import TestCommunity from 'components/blocks/Delta/Inputs/TestCommunity';
import AccordionForm from 'components/blocks/ManagementNewForms/Accordion/AccordionForm';
import FormDatosPersonales from 'components/blocks/ManagementNewForms/ButtonGroups/FormDatosPersonales';
import FormInputFecha from 'components/blocks/ManagementNewForms/Inputs/FormInputFecha';
import FormInputIPF from 'components/blocks/ManagementNewForms/Inputs/FormInputIPF'; import FormBotonSubmit from 'components/blocks/ManagementNewForms/Inputs/FormInputSubmit';
import FormInputText from 'components/blocks/ManagementNewForms/Inputs/FormInputTexto';
import FormObservaciones from 'components/blocks/ManagementNewForms/Inputs/FormObservaciones';
import { opacity } from 'html2canvas/dist/types/css/property-descriptors/opacity';
import React, { useEffect, useState } from 'react'
import { FormProvider, set, useFieldArray, useForm } from 'react-hook-form';
import get from 'lodash/get';
import FormInputTable from 'components/blocks/ManagementNewForms/Inputs/FormInputTable';
import Loader from 'components/blocks/Loader/Loader';
import useCreatetCertificadoEmpresaIt from 'services/record/CertificadoEmpresa/useCreateCertificadoEmpresaIt';
import useUpdateCertificadoEmpresaItByID from 'services/record/CertificadoEmpresa/useUpdateCertificadoEmpresaItByID';
import FormInputGrupoCotizacion from 'components/blocks/ManagementNewForms/Inputs/FormInputGrupoCotizacion';
import FormArrayArchivosReducidos, { adaptDocumentacion, prepareDocumentacionArrayWithCase } from 'components/blocks/ManagementNewForms/ButtonGroups/ArrayInputArchivo';
import TextAreaDefault from 'components/blocks/ManagementNewForms/TextArea/TextAreaDefault';
import FormInputRadioTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputRadioTable';
import FormInputCheckBoxTable from 'components/blocks/ManagementNewForms/ButtonGroups/FormInputCheckBoxTable';
import useCreateReanudacionCATA from 'services/record/ReanudacionCATA/useCreateReanudacionCATA';
import useUpdateReanudacionCATAByID from 'services/record/ReanudacionCATA/useUpdateReanudacionCATAByID';
import InputTextIntegration from 'components/blocks/ManagementNewForms/Inputs/InputTextIntegration';
import FormInfoCreateUpdate from 'components/blocks/ManagementNewForms/Inputs/FormInfoCreateUpdate';


const ReanudacionCATA = ({ info, dataUser, onSuccess }: { info: boolean; dataUser: any, onSuccess?: () => void }) => {


    const formMethods = useForm();
    const { register, handleSubmit, setError, formState: { errors }, setValue, watch, reset, control, getValues } = formMethods;
    const { createReanudacionCATA, dataCreateReanudacionCATA, errorCreateReanudacionCATA, loadingCreateReanudacionCATA, successCreateReanudacionCATA } = useCreateReanudacionCATA();
    const { dataUpdateReanudacionCATAById, errorUpdateReanudacionCATAById, loadingUpdateReanudacionCATAById, successUpdateReanudacionCATAById, updateReanudacionCATAById } = useUpdateReanudacionCATAByID();
    const [datosAPI, setDatosAPI] = useState(dataUser);
    const [bloquearEnvio, setBloquearEnvio] = useState<boolean>(false);
    const [loader, setLoader] = useState(false);


    const [totalSize, setTotalSize] = useState(0);
    const MAX_SIZE_MB = 30;



    const adaptApiResponseToDefaultValues = (data: any) => {
        //console.log(data)
        if (data) {

            reset({
                DatosPersonales: {
                    SolicitanteNombre: data?.DatosPersonales?.Nombre || "",
                    SolicitanteApellido1: data?.DatosPersonales?.Apellido1 || "",
                    SolicitanteApellido2: data?.DatosPersonales?.Apellido2 || "",
                    SolicitanteIPF: data?.DatosPersonales?.IPF || "",
                    SolicitanteIPFTipo: data?.DatosPersonales?.IPFTipo?.toString() || "1",

                    SolicitanteTelefono: data?.DatosPersonales?.Telefono || "",
                    SolicitanteFijo: data?.DatosPersonales?.Fijo || "",
                    SolicitanteDomicilio: data?.DatosPersonales?.Domicilio || "",
                    SolicitanteCodigoPostal: data?.DatosPersonales?.CodigoPostal || "",
                    SolicitanteProvincia: data?.DatosPersonales?.CodigoProvincia || "",
                    SolicitanteProvinciaDescripcion: data?.DatosPersonales?.Provincia || "",
                    SolicitanteComunidadCodigo: data?.DatosPersonales?.CodigoLocalidad || "",
                    SolicitanteEmail: data?.Email || "",
                    SolicitanteFechaNacimiento: data?.FechaNacimiento || "",
                    SolicitanteNumeroSS: data?.DatosPersonales?.NumeroSeguridadSocial || "",
                },

                CausaSolicitud: {
                    CausaReanudacion: data?.CausaReanudacion || ""
                },

                DeclaracionJurada: {
                    DeclaracionJurada: data?.ConfirmacionDeclaracion ?? false,
                    FechaDeclaracion: data?.FechaDeclaracion || null
                },
                DocumentacionAportada: data?.DocumentacionAportada || "",
                Documentacion: adaptDocumentacion(data?.SeccionesDocumentacion),

            });
        }

    }

    useEffect(() => {
        adaptApiResponseToDefaultValues(dataUser);
    }, [dataUser]);

    useEffect(() => {
        setDatosAPI(dataUser);
    }, [dataUser]);




    const onSubmit = async (data: any) => {
        console.log(data);
        setLoader(true);

        let prestacionId = dataUser?.PrestacionId || null;
        const documentacionArray = await prepareDocumentacionArrayWithCase(data?.Documentacion || []);


        const datosEnvio = {
            // IDENTIFICACIÓN
            Id: dataUser?.Id || null,
            ExternalId: dataUser?.ExternalId || 0,
            PersonaId: dataUser?.PersonaId || 0,
            UsuarioId: dataUser?.UsuarioId || null,
            ExpedienteId: dataUser?.ExpedienteId || null,
            PrestacionId: prestacionId,

            Acepto: data?.Acepto ?? false,
            EstadoFormulario: 0,

            // DATOS PERSONALES
            DatosPersonales: {
                Nombre: data?.DatosPersonales?.SolicitanteNombre || "",
                Apellido1: data?.DatosPersonales?.SolicitanteApellido1 || "",
                Apellido2: data?.DatosPersonales?.SolicitanteApellido2 || "",
                IPF: data?.DatosPersonales?.SolicitanteIPF || "",
                IPFTipo: parseInt(data?.DatosPersonales?.SolicitanteIPFTipo) || 1,

                Telefono: data?.DatosPersonales?.SolicitanteTelefono || "",
                Fijo: data?.DatosPersonales?.SolicitanteFijo || "",
                Domicilio: data?.DatosPersonales?.SolicitanteDomicilio || "",
                CodigoPostal: data?.DatosPersonales?.SolicitanteCodigoPostal || "",
                ProvinciaDescripcion: data?.DatosPersonales?.SolicitanteProvinciaDescripcion || null,
                CodigoProvincia: data?.DatosPersonales?.SolicitanteProvincia || null,

                CodigoLocalidad: data?.DatosPersonales?.SolicitanteComunidadCodigo || null,
                LocalidadDescripcion: data?.DatosPersonales?.SolicitanteComunidadCodigoDescripcion || null,

            },

            // CAMPOS DE ESTE FORMULARIO
            CausaReanudacion: data?.CausaSolicitud?.CausaReanudacion || "",

            DocumentacionAportada: data?.DocumentacionAportada || "",

            FechaDeclaracion: data?.DeclaracionJurada?.FechaDeclaracion || null,
            ConfirmacionDeclaracion: data?.DeclaracionJurada?.DeclaracionJurada ?? false,

            // DOCUMENTACIÓN
            Documentacion: documentacionArray
        };

        if (info) {
            createReanudacionCATA(dataUser?.UsuarioId.toString(), datosEnvio, onSuccess)
            setBloquearEnvio(true);
        } else {
            updateReanudacionCATAById(dataUser?.Id, dataUser?.Id, datosEnvio)
            setBloquearEnvio(true);
        }


        setTimeout(() => {
            setLoader(false); //tiempo cargar DOM
        }, 500);
    };





    return (
        <FormProvider {...formMethods}>
            <div className="container form--simple-styled" id="formDeltawithoutleave">

                {/* ////////////// OBSERVACIONES DEL GESTOR A LA SOLICITUD ////////////// */}
                <FormObservaciones observaciones={datosAPI?.Observaciones} titulo={'Observaciones del Gestor a la Solicitud'} />

                <Loader activeLoader={loader || loadingCreateReanudacionCATA || loadingUpdateReanudacionCATAById} label="Cargando Formulario"></Loader>








                {/* ////////////// COMIENZO FORMULARIO ////////////// */}
                {/* ////////////// DATOS DEL TRABAJADOR ////////////// */}
                <FormInfoCreateUpdate
                    isCreate={info}
                    estadoFormulario={datosAPI?.EstadoFormulario ?? datosAPI?.estadoFormulario ?? dataUser?.EstadoFormulario ?? dataUser?.estadoFormulario}
                    estadoFormularioDescripcion={datosAPI?.EstadoFormularioDescripcion ?? datosAPI?.estadoFormularioDescripcion ?? dataUser?.EstadoFormularioDescripcion ?? dataUser?.estadoFormularioDescripcion}
                    fechaActualizacionEstado={datosAPI?.FechaActualizacionEstado ?? datosAPI?.fechaActualizacionEstado ?? dataUser?.FechaActualizacionEstado ?? dataUser?.fechaActualizacionEstado}
                />
                <FormDatosPersonales />

                <AccordionForm title={'Causa de la solicitud de la reanudación'} expandedInit={false} nombreError='CausaSolicitud' >
                    <div className="row mb-4">
                        <div className="col-xl-12">


                            <FieldsetContainer legend="Causa de la solicitud de la reanudación" disabled={false}>

                                <div className="col-xl-12 col-md-12">
                                    <TextAreaDefault
                                        id='CausaSolicitud.CausaReanudacion'
                                        name='CausaSolicitud.CausaReanudacion'
                                        label=''
                                        placeholder=""

                                    />
                                </div>

                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>



                <AccordionForm title={'Documentacion'} expandedInit={false} nombreError='Documentacion' totalSize={totalSize} maxSize={MAX_SIZE_MB} >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="" disabled={false}>

                                <div className="col-xl-12 col-md-12 mt-4">
                                    <TextAreaDefault
                                        id='DocumentacionAportada'
                                        name='DocumentacionAportada'
                                        label='Documentación que aporta'
                                        placeholder=""

                                    />
                                </div>

                                

                            </FieldsetContainer>
                            <FormArrayArchivosReducidos
                                    name={'Documentacion'}
                                    setTotalSize={setTotalSize}
                                />
                        </div>
                    </div>
                </AccordionForm>

                <AccordionForm title={'Declaración Jurada'} expandedInit={false} nombreError='DeclaracionJurada' >
                    <div className="row mb-4">
                        <div className="col-xl-12">
                            <FieldsetContainer legend="Declaración Jurada" disabled={false}>
                                <p>
                                    Declaro, bajo mi responsabilidad que no han variado los hechos y datos declarados en la solicitud inicial de la prestación
                                    de fecha
                                    <InputTextIntegration
                                        name='DeclaracionJurada.FechaDeclaracion'
                                        inputType={4}
                                        req='Es necesario rellenar la fecha'
                                    />
                                    manifestando que quedo enterado de la obligación de comunicar a esta Mutua cualquier
                                    variación que de los mismos pudieran producirse durante la percepción de la prestación de cese de actividad de
                                    trabajadores autónomos.
                                </p>
                                <div className='mb-4'></div>
                                
                            </FieldsetContainer>
                        </div>
                    </div>
                </AccordionForm>














                {/* ////////////// FINAL FORMULARIO ////////////// */}


                {/* ////////////// BLOQUEO DEL ENVIO DEL FORMULARIO //////////// */}
                <FormBotonSubmit
                    disableSubmit={bloquearEnvio}
                    onSubmit={handleSubmit(onSubmit)}
                    successCreate={successCreateReanudacionCATA}
                    successUpdate={successUpdateReanudacionCATAById}
                    errorCreate={errorCreateReanudacionCATA}
                    errorUpdate={errorUpdateReanudacionCATAById}
                    datosAPI={datosAPI}
                    info={info}
                    initExpand={true}
                    totalSizeDocs={totalSize}
                    MaxSizeMB={MAX_SIZE_MB}
                    label='Declara bajo su responsabilidad que son ciertos los datos que se consignan en la presente declaración y que, al día de la fecha, los datos declarados siguen siendo vigentes y asimismo quedo enterado de la obligación de comunicar a la Mutua cualquier variación de los datos en ella expresados, que reclamación de la prestación que hubiera dado lugar.'
                >
                    <div className="mb-4">
                        <p className="paragraph fw-bold">
                            Información sobre solicitud de reanudación
                        </p>
                        <p className="paragraph ">
                            Usted podrá utilizar este impreso para solicitar la reanudación de las prestaciones, excepto para la solicitud de reanudación tras suspensión por trabajo por cuenta propia, siempre que no hayan variado los hechos que motivaron el cese de actividad ni los datos familiares y requisitos personales, desde la última solicitud.
                        </p>
                        <p className="paragraph mt-3 fw-bold">
                            Plazo
                        </p>
                        <p className="paragraph ">
                            En el caso de reanudación, deberá presentar la solicitud al finalizar la causa que originó la suspensión, en el plazo de 15 días hábiles, y acreditar la finalización de la causa de suspensión, así como que se mantiene la situación legal de Cese de Actividad. La reanudación supondrá el derecho a percibir la prestación por el periodo que restase y con la base y porcentaje de la misma que correspondiese en el momento de la suspensión, así como a la cotización correspondiente al mismo período.
                        </p>
                    </div>
                </FormBotonSubmit>


                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    Esta solicitud va a ser tramitada por medios informáticos. Los datos personales que figuran en ella serán incorporados a un fichero de base de datos para el cálculo y control de la prestación económica
                    que se le reconozca, y permanecerán bajo custodia de esta Entidad. En cualquier momento puede ejercitar su derecho de acceso, rectificación, cancelación y oposición sobre los datos incorporados al
                    fichero ( art. 5 de la ley 15/1999 de 13 diciembre de Protección de datos de carácter personal, BOE del día 14)
                </p>

                <p style={{ fontSize: '12px' }} className=' paragraph  text-secondary  mb-4'>
                    En cumplimiento de lo establecido en la normativa sobre de Protección de Datos de Carácter Personal, Solimat Mutua Colaboradora con la Seguridad Social nº 72 le informa que sus datos de carácter
                    personal serán objeto de tratamiento, con la finalidad del mantenimiento y cumplimiento de la relación. La base jurídica que legitima el tratamiento de sus datos es el
                    cumplimiento de una obligación legal. Sus datos serán conservados de forma indefinida en nuestra entidad para atender a las posibles responsabilidades derivadas del tratamiento. Usted
                    podrá revocar el consentimiento prestado, así como ejercitar sus derechos de acceso, rectificación, supresión, oposición, limitación del tratamiento, o portabilidad, en su caso, remitiendo un
                    escrito a la siguiente dirección: Solimat, Mutua Colaboradora con la Seguridad Social nº 72, C/ Berna, 1, 45003, Toledo, adjuntando su NIF. Si considera que sus derechos no han sido
                    debidamente atendidos, puede contactar con nuestro delegado de protección de datos lopd@solimat.com o interponer una reclamación frente a la Agencia Española de Protección de Datos.
                </p>



            </div>
        </FormProvider>
    )
}

export default ReanudacionCATA

